/**
 * Kaza namazı hesapları (mobil services/kaza.service.ts ve kaza ekranlarıyla
 * aynı kurallar). Vitir yalnızca Hanefi mezhebinde kaza edilir.
 */
import { todayString, weekRange } from "./muzakereWeek";

export const KAZA_PRAYERS = ["sabah", "ogle", "ikindi", "aksam", "yatsi", "vitir"];

export const PRAYER_LABEL_KEYS = {
  sabah: "kaza_prayer_sabah",
  ogle: "kaza_prayer_ogle",
  ikindi: "kaza_prayer_ikindi",
  aksam: "kaza_prayer_aksam",
  yatsi: "kaza_prayer_yatsi",
  vitir: "kaza_prayer_vitir",
};

export const MEZHEPS = [
  { id: "hanefi", key: "kaza_mezhep_hanefi" },
  { id: "safii", key: "kaza_mezhep_safii" },
  { id: "maliki", key: "kaza_mezhep_maliki" },
  { id: "hanbeli", key: "kaza_mezhep_hanbeli" },
];

/** Bir yıl kaza hesabı için gün sayısı (güneş yılı). */
export const DAYS_PER_YEAR = 365;

export const emptyKazaCounts = () => ({ sabah: 0, ogle: 0, ikindi: 0, aksam: 0, yatsi: 0, vitir: 0 });

export function prayersFor(mezhep) {
  return mezhep === "hanefi" ? KAZA_PRAYERS : KAZA_PRAYERS.filter((p) => p !== "vitir");
}

export function sumKaza(counts, prayers) {
  return (prayers || []).reduce((acc, p) => acc + (Number(counts?.[p]) || 0), 0);
}

/** Yazılan metinden sayı: rakam dışı karakterler atılır, boşsa 0. */
export function toCount(text) {
  const n = parseInt(String(text ?? "").replace(/[^0-9]/g, ""), 10);
  return Number.isFinite(n) ? n : 0;
}

/** "Kaç yıl, kaç gün kılınmadı": her vakte eklenecek gün sayısı. */
export function daysFromYears(years, days) {
  return toCount(years) * DAYS_PER_YEAR + toCount(days);
}

/** Her vakte gün ekler; eklenecek yoksa aynı nesne döner. */
export function addDaysToPrayers(counts, prayers, addDays) {
  if (!(addDays > 0)) return counts;
  const next = { ...counts };
  prayers.forEach((p) => {
    next[p] = (Number(next[p]) || 0) + addDays;
  });
  return next;
}

/** Taslağa göre anlık kalan: sunucudaki kalan − (taslak − kayıtlı gün). */
export function liveRemaining(kaza, draft, prayer) {
  return (Number(kaza?.remaining?.[prayer]) || 0) - ((Number(draft?.[prayer]) || 0) - (Number(kaza?.day?.[prayer]) || 0));
}

/**
 * Günlük işaretlemede bir vakti bir artırır ya da azaltır. Sıfırın altına
 * inilmez, kalan kaza bitince artırılmaz; değişmezse aynı nesne döner.
 */
export function stepKazaDraft(kaza, draft, prayer, delta) {
  const current = Number(draft?.[prayer]) || 0;
  const nextValue = current + delta;
  if (nextValue < 0) return draft;
  if (delta > 0 && liveRemaining(kaza, draft, prayer) <= 0) return draft;
  return { ...draft, [prayer]: nextValue };
}

/** Günlük hedeflerle aynı pencere: bu haftanın Pazartesi'sinden bugüne. */
export function canEditKazaDay(date, today = todayString()) {
  return date <= today && date >= weekRange(today).start;
}

/** Terakkim'de kaza yuvarlağı: borç bitene kadar her gün, bittiği gün kılınan da görünsün. */
export function showKazaCircle(kaza) {
  if (!kaza || !kaza.isSetUp) return false;
  const prayers = kaza.prayers || prayersFor(kaza.mezhep);
  return sumKaza(kaza.remaining, prayers) > 0 || sumKaza(kaza.day, prayers) > 0;
}
